import {NamedFeature} from '@im-js/token';

/**
 * 데이터베이스 일괄 처리 기능 식별
 */
export const DB_RESTORE = new NamedFeature('#DB_RESTORE');